const mapping = {
    impressions: 'impressions',
    clicks: 'total_clickthrough',
    leads: 'total_lead',
    spend: 'spend',
    cpm: 'cpm',
};

export default mapping;
